import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const EyeHealthDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Kesehatan Mata", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Kesehatan Mata",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-primary-hg tw-text-xs">Tanggal</div>
          <div className="tw-mb-3">
            {moment(state.tanggal ?? Date.now()).format(
              "dddd, DD MMMM YYYY | HH:mm"
            )}
          </div>
          <div className="tw-text-primary-hg tw-text-xs">Petugas</div>
          <div className="tw-mb-3">{state.petugas ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Mata Kanan</div>
          <div className="tw-mb-3">{state.mataKanan ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Nilai Mata Kanan</div>
          <div className="tw-mb-3">{state.nilaiMataKanan ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Mata Kiri</div>
          <div className="tw-mb-3">{state.mataKiri ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Nilai Mata Kiri</div>
          <div className="tw-mb-3">{state.nilaiMataKiri ?? "-"}</div>
        </div>
      </div>
    </>
  );
};
